import { RootState } from "../../app/store";
import { Base64 } from "js-base64";
import { SkillTrainerState } from "./skillTrainerSlice";
import { Skill } from "../../models/skill";
import { BitStream } from "bit-buffer";

class SkillShareUtil
{
  encode = (state: RootState): string => {
    const trainer = state.skillTrainer;
    const maxIdNum = trainer.skills.reduce((a, b) => Math.max(a, b.idNum), 0);
    const race = trainer.races.find(x => x.id === trainer.raceId);
    const profession = trainer.professions.find(x => x.id === trainer.professionId);
    const stream = new BitStream(new ArrayBuffer(256));
    
    stream.writeUint8(1); //Version 1
    stream.writeUint8(trainer.strn);
    stream.writeUint8(trainer.intl);
    stream.writeUint8(trainer.wilp);
    stream.writeUint8(trainer.dext);
    stream.writeUint8(trainer.cont);
    stream.writeUint8(race?.idNum ?? 0);
    stream.writeUint8(profession?.idNum ?? 0);
    for (let i = 1; i <= maxIdNum; i++) {
      const skill = trainer.skills.find(x => x.idNum === i && x.percentTarget);
      stream.writeBoolean(!!skill);
      if (skill) {
        stream.writeUint8(skill.percentTarget);
      }
    }

    const view = new Uint8Array(stream.buffer, 0, stream.byteIndex);
    return Base64.fromUint8Array(view, true);
  }

  decode = (data: string) => {
    const trainer = { skills: [] as Skill[] } as SkillTrainerState;
    const view = Base64.toUint8Array(data);
    const stream = new BitStream(view.buffer);

    const version = stream.readUint8();
    if (version === 1) {
      trainer.strn = stream.readUint8();
      trainer.intl = stream.readUint8();
      trainer.wilp = stream.readUint8();
      trainer.dext = stream.readUint8();
      trainer.cont = stream.readUint8();
      trainer.raceId = stream.readUint8().toString();
      trainer.professionId = stream.readUint8().toString();
      for (let i = 1; stream.bitsLeft; i++) {
        if (stream.readBoolean()) {
          const skill = {} as Skill;
          skill.idNum = i;
          skill.percentTarget = stream.readUint8();
          trainer.skills.push(skill);
        }
      }
    }

    return trainer;
  }
}

export const skillShareUtil = new SkillShareUtil();
